module.exports = __webpack_public_path__ + "images/179_640.jpg";